import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ColumnComponent } from './column/column.component';
import { BreakpointObserver } from '@angular/cdk/layout';

@Component({
  selector: 'app-table',
  standalone: true,
  imports: [CommonModule, ColumnComponent],
  templateUrl: './table.component.html',
  styleUrl: './table.component.scss',
})
export class TableComponent {
  @Input() data: any[] = [];
  @Input() bgClass?: { [key: string]: string };
  @Input() headersStyle?: { [key: string]: string };
  @Input() columns: {
    header: string;
    field: string;
    type?: string;
    class?: string;
  }[] = [];

  // Zoom related properties for breakpoint observer
  isZoomed: boolean = false;

  constructor(private breakpointObserver: BreakpointObserver) {
    this.breakpointObserver
      .observe(['(max-width: 800px)'])
      .subscribe((result) => {
        this.isZoomed = result.matches;
      });
  }
}
